import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/api";

const C_HILO = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#d0d0d0","#DC2626","#aaaaaa","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const N_HILO = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];
function cH(h){ return C_HILO[(parseInt(h)-1)%12]; }
function nH(h){ return N_HILO[(parseInt(h)-1)%12]; }

const S = {
  overlay:{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.88)",zIndex:900,overflowY:"auto"},
  wrap:   {maxWidth:1000,width:"100%",margin:"0 auto",padding:"12px 12px 40px"},
  card:   {background:"#1a1a2e",border:"1px solid #2a2a4a",borderRadius:8,padding:"12px",marginBottom:10},
  title:  {fontSize:11,color:"#C4B5FD",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8},
  select: {background:"#0f0f1a",border:"1px solid #374151",borderRadius:5,color:"#F9FAFB",padding:"3px 6px",fontSize:10,width:"100%"},
  input:  {background:"#0f0f1a",border:"1px solid #374151",borderRadius:5,color:"#F9FAFB",padding:"3px 6px",fontSize:10,width:"100%"},
  btn:    {background:"#7C3AED",color:"#fff",border:"none",borderRadius:5,padding:"4px 10px",fontSize:10,cursor:"pointer",fontWeight:600},
  btnSm:  {background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid #F87171",borderRadius:4,padding:"2px 7px",fontSize:9,cursor:"pointer"},
  btnClose:{background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid #F87171",borderRadius:6,padding:"6px 16px",fontSize:12,cursor:"pointer",fontWeight:600},
  th:     {padding:"4px 8px",fontSize:9,color:"#6B7280",textAlign:"left",borderBottom:"1px solid #2a2a4a",whiteSpace:"nowrap"},
  td:     {padding:"3px 6px",fontSize:10,borderBottom:"1px solid #151525",verticalAlign:"middle"},
};

function AutoConectar({fibras, puertos, totalOdf, onAutoConectar}){
  const [fibra, setFibra]   = useState("");
  const [desde, setDesde]   = useState(1);
  const [saving, setSaving] = useState(false);

  const fibSel = fibras.find(f=>String(f.id)===String(fibra));
  const numH   = fibSel ? parseInt(fibSel.tipo_hilos)||12 : 0;

  // Primer puerto ODF libre
  const primerLibre = ()=>{
    for(let i=1;i<=totalOdf;i++){
      if(!puertos.find(p=>p.puerto_odf===i&&p.fibra_id)) return i;
    }
    return 1;
  };

  return(
    <div style={{background:"rgba(124,58,237,0.08)",border:"1px solid #7C3AED44",borderRadius:6,padding:"8px 10px",marginBottom:10}}>
      <div style={{fontSize:10,color:"#C4B5FD",fontWeight:600,marginBottom:6}}>⚡ Autoconectar fibra</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"flex-end"}}>
        <div>
          <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Fibra</div>
          <select style={{background:"#0f0f1a",border:"1px solid #374151",borderRadius:5,color:"#F9FAFB",padding:"3px 6px",fontSize:10}}
            value={fibra} onChange={e=>{ setFibra(e.target.value); setDesde(primerLibre()); }}>
            <option value="">Selecciona fibra...</option>
            {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
          </select>
        </div>
        <div>
          <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Desde puerto ODF</div>
          <input type="number" min={1} max={totalOdf} style={{background:"#0f0f1a",border:"1px solid #374151",borderRadius:5,color:"#F9FAFB",padding:"3px 6px",fontSize:10,width:70}}
            value={desde} onChange={e=>setDesde(parseInt(e.target.value)||1)}/>
        </div>
        {fibra&&numH>0&&(
          <div style={{fontSize:9,color:"#6B7280",alignSelf:"center"}}>
            Conectará {numH} hilos → ODF {desde} al {desde+numH-1}
          </div>
        )}
        <button
          disabled={!fibra||saving}
          onClick={async()=>{ setSaving(true); await onAutoConectar(fibra,desde,numH); setSaving(false); }}
          style={{background:fibra?"#7C3AED":"#374151",color:"#fff",border:"none",borderRadius:5,padding:"4px 12px",fontSize:10,cursor:fibra?"pointer":"default",fontWeight:600}}>
          {saving?"Conectando...":"⚡ Autoconectar"}
        </button>
      </div>
    </div>
  );
}

function OdfRow({puerto, fibras, numSlots, pxSlot, onGuardar, onLimpiar, canEdit}){
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({
    puerto_olt_slot: puerto.puerto_olt_slot??'',
    puerto_olt_num:  puerto.puerto_olt_num??'',
    fibra_id:        puerto.fibra_id??'',
    hilo_num:        puerto.hilo_num??'',
    observacion:     puerto.observacion??'',
    estado:          puerto.estado??'libre',
  });

  const ocupado = !!puerto.fibra_id;
  const hColor  = puerto.hilo_num ? cH(puerto.hilo_num) : "#374151";
  const hNom    = puerto.hilo_num ? nH(puerto.hilo_num) : "";
  const fibNom  = puerto.fibra_nombre||"";

  // Hilos disponibles de la fibra seleccionada
  const fibSel  = fibras.find(f=>String(f.id)===String(form.fibra_id));
  const numHilos= fibSel ? parseInt(fibSel.tipo_hilos)||12 : 12;

  return(
    <>
      <tr style={{background:ocupado?"rgba(16,185,129,0.05)":"transparent"}}>
        <td style={S.td}>
          {puerto.puerto_olt_slot!==null && puerto.puerto_olt_num!==null
            ? <span style={{color:"#C4B5FD",fontSize:10}}>{puerto.puerto_olt_slot}/{puerto.puerto_olt_num}</span>
            : <span style={{color:"#374151",fontSize:9}}>—</span>}
        </td>
        <td style={{...S.td,color:"#7C3AED",fontWeight:700}}>ODF {puerto.puerto_odf}</td>
        <td style={S.td}>
          {ocupado
            ? <div style={{display:"flex",alignItems:"center",gap:4}}>
                <div style={{width:7,height:7,borderRadius:"50%",background:hColor}}/>
                <span style={{color:hColor,fontSize:10}}>{fibNom} H{puerto.hilo_num} {hNom}</span>
              </div>
            : <span style={{color:"#374151",fontSize:9}}>— libre —</span>}
        </td>
        <td style={{...S.td,maxWidth:150}}>
          <span style={{color:"#6B7280",fontSize:9}}>{puerto.observacion||""}</span>
        </td>
        <td style={{...S.td,color:puerto.estado==="activo"?"#10B981":puerto.estado==="danado"?"#F87171":"#374151",fontSize:9}}>
          {puerto.estado}
        </td>
        {canEdit&&<td style={S.td}>
          <div style={{display:"flex",gap:3}}>
            <button style={S.btn} onClick={()=>setEdit(!edit)}>{edit?"▲":"✎"}</button>
            {ocupado&&<button style={S.btnSm} onClick={()=>onLimpiar(puerto.puerto_odf)}>✕</button>}
          </div>
        </td>}
      </tr>
      {edit&&canEdit&&(
        <tr style={{background:"rgba(124,58,237,0.08)"}}>
          <td colSpan={6} style={{...S.td,padding:"8px 10px"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:6}}>
              {/* Puerto OLT */}
              <div>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Puerto OLT (slot)</div>
                <select style={S.select} value={form.puerto_olt_slot} onChange={e=>setForm(x=>({...x,puerto_olt_slot:e.target.value}))}>
                  <option value="">—</option>
                  {Array.from({length:numSlots},(_,s)=><option key={s} value={s}>Slot {s}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Puerto OLT (num)</div>
                <select style={S.select} value={form.puerto_olt_num} onChange={e=>setForm(x=>({...x,puerto_olt_num:e.target.value}))}>
                  <option value="">—</option>
                  {Array.from({length:pxSlot},(_,p)=><option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              {/* Fibra */}
              <div>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Fibra</div>
                <select style={S.select} value={form.fibra_id} onChange={e=>setForm(x=>({...x,fibra_id:e.target.value,hilo_num:''}))}>
                  <option value="">— Sin fibra —</option>
                  {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
                </select>
              </div>
              {/* Hilo */}
              <div>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Hilo</div>
                <select style={S.select} value={form.hilo_num} onChange={e=>setForm(x=>({...x,hilo_num:e.target.value}))}>
                  <option value="">— Hilo —</option>
                  {Array.from({length:numHilos},(_,i)=>(
                    <option key={i+1} value={i+1} style={{color:cH(i+1)}}>H{i+1} {nH(i+1)}</option>
                  ))}
                </select>
              </div>
              {/* Observacion */}
              <div style={{gridColumn:"span 2"}}>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Observación</div>
                <input style={S.input} value={form.observacion} onChange={e=>setForm(x=>({...x,observacion:e.target.value}))} placeholder="Ej: Hacia Mufa M1, Biocontrol..."/>
              </div>
              {/* Estado */}
              <div>
                <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>Estado</div>
                <select style={S.select} value={form.estado} onChange={e=>setForm(x=>({...x,estado:e.target.value}))}>
                  <option value="libre">Libre</option>
                  <option value="activo">Activo</option>
                  <option value="danado">Dañado</option>
                </select>
              </div>
            </div>
            <div style={{marginTop:6,display:"flex",gap:6}}>
              <button style={S.btn} onClick={()=>{onGuardar(puerto.puerto_odf,form);setEdit(false);}}>Guardar</button>
              <button style={{...S.btnSm,border:"1px solid #374151",color:"#6B7280"}} onClick={()=>setEdit(false)}>Cancelar</button>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default function OltDiagram({olt, user, onClose}){
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");
  const [filtro,  setFiltro]  = useState("todos");

  const canEdit = user?.rol && ["admin","tecnico","administrador","gerente"].includes(user.rol);

  const cargar = ()=>{
    setLoading(true);
    apiFetch("/olt_diagram.php?olt_id="+olt.id).then(d=>{
      if(d.success) setData(d);
      else setError(d.error||"Error");
      setLoading(false);
    }).catch(()=>{ setError("Error de conexión"); setLoading(false); });
  };

  useEffect(()=>{
    cargar();
    // Generar puertos ODF si no existen
    apiFetch("/olt_diagram.php?olt_id="+olt.id, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body:JSON.stringify({accion:"generar_odf_default", num_odf:parseInt(olt.puertos_odf||0), puertos_por_slot:parseInt(olt.puertos_por_slot||8), num_slots:parseInt(olt.num_slots||1)})
    }).then(()=>cargar());
  },[olt.id]);

  const guardarPuerto = async(puerto_odf, form)=>{
    await apiFetch("/olt_diagram.php?olt_id="+olt.id, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body:JSON.stringify({accion:"guardar_odf_puerto", puerto_odf, ...form})
    });
    cargar();
  };

  const autoConectar = async(fibra_id, desde, numHilos)=>{
    const fibSel = data?.fibras?.find(f=>String(f.id)===String(fibra_id));
    if(!fibSel) return;
    const totalH = parseInt(fibSel.tipo_hilos)||12;
    const promises = [];
    for(let i=0; i<totalH; i++){
      const puerto_odf = desde + i;
      const hilo_num   = i + 1;
      if(puerto_odf > (parseInt(data?.olt?.puertos_odf)||0)) break;
      const pExist = (data?.odf_puertos||[]).find(p=>parseInt(p.puerto_odf)===puerto_odf);
      promises.push(
        apiFetch("/olt_diagram.php?olt_id="+olt.id, {
          method:"POST", headers:{"Content-Type":"application/json"},
          body:JSON.stringify({
            accion:"guardar_odf_puerto",
            puerto_odf,
            puerto_olt_slot: pExist?.puerto_olt_slot??'',
            puerto_olt_num:  pExist?.puerto_olt_num??'',
            fibra_id,
            hilo_num,
            estado:"activo",
            observacion:`${fibSel.nombre} H${hilo_num}`,
          })
        })
      );
    }
    await Promise.all(promises);
    cargar();
  };

  const limpiarPuerto = async(puerto_odf)=>{
    if(!window.confirm("¿Limpiar este puerto ODF?")) return;
    await apiFetch("/olt_diagram.php?olt_id="+olt.id, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body:JSON.stringify({accion:"limpiar_odf_puerto", puerto_odf})
    });
    cargar();
  };

  if(loading) return <div style={S.overlay}><div style={{color:"#C4B5FD",textAlign:"center",marginTop:80}}>Cargando...</div></div>;

  const o = data?.olt||olt;
  const numSlots = parseInt(o.num_slots)||1;
  const pxSlot   = parseInt(o.puertos_por_slot)||8;
  const totalOlt = numSlots * pxSlot;
  const totalOdf = parseInt(o.puertos_odf)||0;
  const tieneOdf = !!parseInt(o.tiene_odf||0);
  const puertos  = data?.odf_puertos||[];
  const ocupados = puertos.filter(p=>p.fibra_id).length;

  const filtrados = puertos.filter(p=>{
    if(filtro==="ocupados") return !!p.fibra_id;
    if(filtro==="libres")   return !p.fibra_id;
    return true;
  });

  return(
    <div style={S.overlay}>
      <div style={S.wrap}>
        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
          <div>
            <h2 style={{margin:0,color:"#C4B5FD",fontSize:16}}>{o.nombre}</h2>
            <p style={{margin:"2px 0 0",fontSize:10,color:"#6B7280"}}>
              {o.marca} {o.modelo} · {numSlots} slot(s) × {pxSlot} puertos = {totalOlt} puertos OLT
              {tieneOdf&&<span style={{color:"#FBBF24",marginLeft:6}}>· ODF {totalOdf} puertos · {ocupados} ocupados · {totalOdf-ocupados} libres</span>}
            </p>
          </div>
          <button onClick={onClose} style={S.btnClose}>✕ Cerrar</button>
        </div>

        {error&&<p style={{color:"#F87171",fontSize:11}}>{error}</p>}

        {/* Resumen OLT → ODF */}
        <div style={S.card}>
          <div style={S.title}>Diagrama: OLT → ODF → Fibra</div>

          {/* Filtros */}
          <div style={{display:"flex",gap:4,marginBottom:8}}>
            {[["todos","Todos"],["ocupados","Ocupados"],["libres","Libres"]].map(([v,l])=>(
              <button key={v} onClick={()=>setFiltro(v)} style={{padding:"2px 8px",borderRadius:8,border:"1px solid #374151",background:filtro===v?"#7C3AED":"transparent",color:filtro===v?"#fff":"#9CA3AF",fontSize:9,cursor:"pointer"}}>{l}</button>
            ))}
            <span style={{fontSize:9,color:"#6B7280",marginLeft:8,alignSelf:"center"}}>{ocupados}/{totalOdf} ocupados</span>
          </div>

          {/* AUTOCONECTAR */}
          <AutoConectar fibras={data?.fibras||[]} puertos={puertos} totalOdf={totalOdf} onAutoConectar={autoConectar}/>

          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr>
                <th style={S.th}>Puerto OLT</th>
                <th style={S.th}>Puerto ODF</th>
                <th style={S.th}>Fibra → Hilo</th>
                <th style={S.th}>Observación</th>
                <th style={S.th}>Estado</th>
                {canEdit&&<th style={S.th}>Acción</th>}
              </tr>
            </thead>
            <tbody>
              {filtrados.map(p=>(
                <OdfRow
                  key={p.id||p.puerto_odf}
                  puerto={p}
                  fibras={data?.fibras||[]}
                  numSlots={numSlots}
                  pxSlot={pxSlot}
                  onGuardar={guardarPuerto}
                  onLimpiar={limpiarPuerto}
                  canEdit={canEdit}
                />
              ))}
            </tbody>
          </table>
        </div>

              </div>
    </div>
  );
}
